import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	cancelButton: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Action button to exit the modal for adding or editing a priority',
	},
	colorPickerLightGrey: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-light-grey',
		defaultMessage: 'Light grey',
		description: 'Light grey option in color picker for status of priority',
	},
	colorPickerGrey: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-grey',
		defaultMessage: 'Grey',
		description: 'Grey option in color picker for status of priority',
	},
	colorPickerDarkGrey: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-dark-grey',
		defaultMessage: 'Dark grey',
		description: 'Dark grey option in color picker for status of priority',
	},
	colorPickerLightBlue: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-light-blue',
		defaultMessage: 'Light blue',
		description: 'Light blue option in color picker for status of priority',
	},
	colorPickerBlue: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-blue',
		defaultMessage: 'Blue',
		description: 'Blue option in color picker for status of priority',
	},
	colorPickerDarkBlue: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-dark-blue',
		defaultMessage: 'Dark blue',
		description: 'Dark blue option in color picker for status of priority',
	},
	colorPickerLightTeal: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-light-teal',
		defaultMessage: 'Light teal',
		description: 'Light teal option in color picker for status of priority',
	},
	colorPickerTeal: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-teal',
		defaultMessage: 'Teal',
		description: 'Teal option in color picker for status of priority',
	},
	colorPickerDarkTeal: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-dark-teal',
		defaultMessage: 'Dark teal',
		description: 'Dark teal option in color picker for status of priority',
	},
	colorPickerLightGreen: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-light-green',
		defaultMessage: 'Light green',
		description: 'Light green option in color picker for status of priority',
	},
	colorPickerGreen: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-green',
		defaultMessage: 'Green',
		description: 'Green option in color picker for status of priority',
	},
	colorPickerDarkGreen: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-dark-green',
		defaultMessage: 'Dark green',
		description: 'Dark green option in color picker for status of priority',
	},
	colorPickerLightYellow: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-light-yellow',
		defaultMessage: 'Light yellow',
		description: 'Light yellow option in color picker for status of priority',
	},
	colorPickerYellow: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-yellow',
		defaultMessage: 'Yellow',
		description: 'Yellow option in color picker for status of priority',
	},
	colorPickerDarkYellow: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-dark-yellow',
		defaultMessage: 'Dark yellow',
		description: 'Dark yellow option in color picker for status of priority',
	},
	colorPickerLightRed: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-light-red',
		defaultMessage: 'Light red',
		description: 'Light red option in color picker for status of priority',
	},
	colorPickerRed: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-red',
		defaultMessage: 'Red',
		description: 'Red option in color picker for status of priority',
	},
	colorPickerDarkRed: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-dark-red',
		defaultMessage: 'Dark red',
		description: 'Dark red option in color picker for status of priority',
	},
	colorPickerLightPurple: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-light-purple',
		defaultMessage: 'Light purple',
		description: 'Light green option in color picker for status of priority',
	},
	colorPickerPurple: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-purple',
		defaultMessage: 'Purple',
		description: 'Green option in color picker for status of priority',
	},
	colorPickerDarkPurple: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-dark-purple',
		defaultMessage: 'Dark purple',
		description: 'Dark green option in color picker for status of priority',
	},
	colorPickerFieldLabel: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-field-label',
		defaultMessage: 'Color',
		description: 'Field label for color in the form to add or edit a priority ',
	},
	colorPickerButtonTitle: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-button-title',
		defaultMessage: 'Color picker button',
		description: 'Field label for color in the form to add or edit a priority ',
	},
	colorPickerValidationError: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.color-picker-validation-error',
		defaultMessage: 'You must select a color.',
		description: 'Form validation error for having no color selection when adding a priority',
	},
	nameFieldLabel: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.name-field-label',
		defaultMessage: 'Name',
		description: 'Field label for name in the form to add or edit a priority ',
	},
	nameFieldPlaceholder: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.name-field-placeholder',
		defaultMessage: 'Enter priority name',
		description: 'Field label for name in the form to add or edit a priority ',
	},
	nameValidationErrorRequired: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.name-validation-error-required',
		defaultMessage: 'You must specify a name for the priority.',
		description: 'Form validation error for having no name when adding or editing a priority',
	},
	nameValidationErrorDuplicateName: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.name-validation-error-duplicate-name',
		defaultMessage: '{name} already exists. Enter another priority name.',
		description: 'Form validation error for having no name when adding or editing a priority',
	},
	descriptionFieldLabel: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.description-field-label',
		defaultMessage: 'Description',
		description: 'Field label for description in the form to add or edit a priority ',
	},
	descriptionFieldPlaceholder: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.description-field-placeholder',
		defaultMessage: 'Enter priority description',
		description: 'Field label for name in the form to add or edit a priority ',
	},
	iconFieldLabel: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.icon-field-label',
		defaultMessage: 'Icon',
		description: 'Field label for icon in the form to add or edit a priority ',
	},
	iconButtonLabel: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.icon-button-label',
		defaultMessage: 'Choose icon',
		description: 'Button text to choose icon in the form to add or edit a priority',
	},
	iconButtonUgcWarningText: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.icon-button-ugc-warning-text',
		defaultMessage: 'Icons may display online.',
		description: 'A user warning that the uploaded icon images may be seen by the public.',
	},
	iconValidationError: {
		id: 'admin-pages-priorities.priority-sidebars.form.form-fields.icon-validation-error',
		defaultMessage: 'You must select an icon for the priority.',
		description: 'Form validation error for having no icon when adding or editing a priority',
	},
	invalidColorMessage: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
		id: 'admin-pages-priorities.priority-modals.form-modal.form-fields.invalid-color-message',
		defaultMessage: "If you change the color, you won't be able to select {color} in future.",
		description:
			'Message to inform user that the color they have selected is no longer supported and if they update it, it will be lost.',
	},
});
